import { db } from '~/services/firebase';
import { getUsers, User } from '~/services/users';

import moment, { Moment } from 'moment';
import firebase from 'firebase';
import { SelectedDays } from '~/screens';
require('moment/locale/da');


export type RegistrationDays = {
    [index: string]: DayData
    monday: DayData
    tuesday: DayData
    wednesday: DayData
    thursday: DayData
    friday: DayData
}

export type DayData = {
    registered: boolean
    locationId: string | null 
    guests: number
}

export type Registration = {
    uid: string
    user: User | undefined
    updated: Moment
    days: RegistrationDays
}

export const getRegistrations = async (date: Moment, locationFilter: string) => {
    return new Promise<Registration[]>(resolve => {

        const weekId = moment(date).format('YYYY-MM-DD');

        let query = db.collection('registrations').doc(weekId).collection('users');

        if (locationFilter !== 'all') {
            query = query.where(`days.${locationFilter}.registered`, '==', true);
        }
        // get all users
        getUsers().then((users: User[]) => {
            const weekId = moment(date).format('YYYY-MM-DD')
            db.collection('registrations').doc(weekId).collection('users').get().then((querySnapshot) => {
                let registrations: Registration[] = []
                querySnapshot.forEach((doc) => {
                    let data = doc.data()
                    let updated = moment(data.updated.toDate())
                    let days = { ...data }
                    delete days.updated
                    registrations.push({
                        uid: doc.id,
                        user: users.find((u) => u.uid == doc.id),
                        updated: updated,
                        days: <RegistrationDays>days,
                    })
                })
                resolve(registrations)
            })
        })
    })
}

export const updateRegistration = async (date: Moment, userId: string, selectedDays: SelectedDays) => {
    return new Promise((resolve, reject) => {
        const weekId = moment(date).format('YYYY-MM-DD');
        const registration = {
            monday: { registered: selectedDays.monday.registered, locationId: null, guests: selectedDays.monday.guests },
            tuesday: { registered: selectedDays.tuesday.registered, locationId: null, guests: selectedDays.tuesday.guests },
            wednesday: { registered: selectedDays.wednesday.registered, locationId: null, guests: selectedDays.wednesday.guests },
            thursday: { registered: selectedDays.thursday.registered, locationId: null, guests: selectedDays.thursday.guests },
            friday: { registered: selectedDays.friday.registered, locationId: null, guests: selectedDays.friday.guests },
        }
        
        db.collection('registrations').doc(weekId).collection('users').doc(userId).set({
            updated: firebase.firestore.FieldValue.serverTimestamp(),
            ...registration,
        }, { merge: true })
            .then(() => {
                resolve(true)
            })
            .catch((error) => {
                console.error("Error updating registration: ", error)
                reject(error)
            })
    })
}
